export const avatarSize = 72
export const companies = [
  { name: 'exp', width: 188, height: 70 },
  { name: 'compass', width: 268, height: 36 },
  { name: 'the-agency', width: 256, height: 114 },
  { name: 'berkshire', width: 228, height: 160 },
  { name: 'engel-volkers', width: 400, height: 108 },
  { name: 'sothebys', width: 290, height: 58 },
  { name: 'kw', width: 254, height: 114 },
  { name: 'century-21', width: 286, height: 34 }
]
